export const socialIconList = [
  {
    name: 'github',
    prefix: 'fab', // fab prefix for brands, fas for solid icons
    link: 'https://github.com/mittalsam20',
  },
  {
    name: 'linkedin',
    prefix: 'fab',
    link: 'https://www.linkedin.com/in/samaksh-mittal-511335290/',
  },

  {
    name: 'portrait',
    prefix: 'fas',
    link: 'https://drive.google.com/file/d/1rVo81b7N_Iufahz24gke-exJxu4xHW9y/view',
  },
  // {
  //   name: 'blog',
  //   prefix: 'fas',
  //   link: '/blog',
  // },
  // Add further social links with the icon of choice and link here
  // check https://fontawesome.com/icons?d=gallery&s=brands for other brand icons
];
